<template>
  <div class="my-page-container">
    <div class="profile-banner">
      <img class="avatar" v-if="userInfo.headimgUrl" :src="userInfo.headimgUrl" />
    </div>
    <div class="user-info">
      <div class="desc">
        <div class="info">
          <span class="real-name">{{ userInfo.name }}</span>
          <span class="gender m"></span>
        </div>
        <div class="nickname">{{ userInfo.nickname }}</div>
      </div>
    </div>
    <div class="my-card" v-for="item in filteredList" :key="item.id" @click="onClickCardItem(item)">
      <img :src="item.src" class="left-img">
      <span class="label">{{ item.label }}</span>
      <img :src="item.arrow" class="arrow">
    </div>
  </div>
</template>
<script>
import cardList from './list'
import { hasOneOf } from '@/util'
import { fetchUserInfo } from '@/services/UserService'

export default {
  data() {
    return {
      openId: localStorage.getItem('openId'),
      cardList,
      userInfo: {}
    }
  },
  computed: {
    filteredList() {
      return cardList.filter(item => {
        if (!item.roleCodeList) {
          return true
        } else {
          return hasOneOf(item.roleCodeList, this.userInfo.roleCodeList || [])
        }
      })
    }
  },
  async mounted() {
    await this.onInitUserInfo()
  },
  methods: {
    async onInitUserInfo() {
      const response = await fetchUserInfo({
        openId: this.openId
      })
      this.userInfo = response.data
    },
    onClickCardItem(item) {
      this.$router.push(item.path)
    }
  }
}
</script>
<style lang="less">
.my-page-container {
  height: calc(100vh - 55px);
  background-color: #f5f5f5;
  overflow: auto;

  .profile-banner {
    width: 100%;
    height: 192px;
    background-image: url(https://assets.maizuo.com/h5/v5/public/app/img/bg.a5bdd690.png);
    display: flex;
    justify-content: center;
    align-items: center;

    .avatar {
      border-radius: 50%;
      width: 100px;
      height: 100px;
    }
  }

  .user-info {
    background-color: #fff;
    padding: 15px;
    margin-bottom: 10px;

    .desc {
      .real-name {
        font-size: 19px;
        color: #494949;
        margin-right: 5px;
      }

      .gender {
        display: inline-block;
        width: 10px;
        height: 10px;
        background-size: contain;

        &.m {
          background-image: url(https://img1.doubanio.com/f/talion/95a57160a10807da4a64c37ad16c6f763a324be1/pics/card/people_male.png);
        }

        &.f {
          background-image: url(https://img1.doubanio.com/f/talion/71805678cceef358833d8cc8fd7a46dac3c528af/pics/card/people_female.png)
        }
      }

      .nickname {
        font-size: 13px;
        color: #9b9b9b;
        margin-top: 2px;
      }
    }
  }

  .my-card {
    position: relative;
    background: #fff;
    padding: 0 15px;
    height: 49px;
    display: flex;
    align-items: center;

    &::after {
      content: " ";
      position: absolute;
      left: 0;
      bottom: 0;
      right: 0;
      height: 1px;
      border-bottom: 1px solid #ededed;
      color: #ededed;
      transform-origin: 0 100%;
      transform: scaleY(.5);
      left: 13px;
    }

    .left-img {
      width: 20px;
      height: 20px;
    }

    .label {
      font-size: 15px;
      margin-left: 15px;
      color: #191a1b;
      flex: 1;
    }

    .arrow {
      text-align: right;
      width: 6px;
      height: 10px;
    }
  }
}
</style>
